import { render, staticRenderFns } from "./loader.component.vue?vue&type=template&id=0ff3aa4f&scoped=true"
import script from "./loader.component.vue?vue&type=script&lang=js"
export * from "./loader.component.vue?vue&type=script&lang=js"
import style0 from "./loader.component.vue?vue&type=style&index=0&id=0ff3aa4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff3aa4f",
  null
  
)

export default component.exports